import axios from 'axios';
import { Vue } from 'vue-property-decorator';
import { WritableStream } from 'web-streams-polyfill/ponyfill';
import streamSaver from 'streamsaver';

const CancelToken = axios.CancelToken;

export default class FileDownloader {
  private file: any;
  public callbackProgress: (current: number, total: number) => void = null;
  public callbackFinished: () => void = null;
  private qmUUID: string = null;
  private isDownloading: boolean = false;
  private writer: any = null;
  private abortController: any = null;

  constructor(qmUUID: string) {
    this.qmUUID = qmUUID;
  }

  public download(type: string, uuid: string, fileName: string) {
    this.downloadALink(type, uuid, fileName);
  }

  private downloadALink(type: string, uuid: string, fileName: string) {
    Vue.axios
      // .get(`/movie/${type}/${uuid}/download`, {
      .get(`/quote_movie/${this.qmUUID}/movie/${type}/${uuid}/download`, {
        params: {
          file_name: fileName,
        },
      })
      .then((result: any) => {
        const element = document.createElement('a');
        element.setAttribute('href', result.data.url);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private downloadFetch(type: string, uuid: string, fileName: string) {
    //get presigned url
    Vue.axios
      .get(`/movie/${type}/${uuid}/download`)
      .then((result: any) => {
        if (result.status !== 200) {
          throw new Error(`unable to get download presigned url for ${uuid}`);
        }

        if ('BackgroundFetchManager' in self) {
          console.log('we have background fetch');
        } else {
          console.log('no background fetch');
        }

        //start download using fetch
        this.isDownloading = true;
        this.abortController = new AbortController();
        return fetch(result.data.url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          signal: this.abortController.signal,
        });
      })
      .then((response: any) => {
        if (!(window as any).WritableStream) {
          streamSaver.WritableStream = WritableStream;
          (window as any).WritableStream = WritableStream;
        }
        const fileStream = streamSaver.createWriteStream(fileName);
        const readableStream = response.body;

        if (readableStream.pipeTo) {
          return readableStream.pipeTo(fileStream);
        }
        this.writer = fileStream.getWriter();

        const reader = response.body.getReader();
        const pump = () => console.log('pumping');
        reader.read().then((res) => (res.done ? this.writer.close() : this.writer.write(res.value).then(pump)));

        pump();
      })
      .catch((error: any) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted');
        } else {
          console.log(error);
        }
      });
  }

  public cancel() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  public downloading() {
    return this.isDownloading;
  }
}
